export default __webpack_public_path__ + "static/media/Group 5674@2x.bd2b6b4b.png";